var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.label && _vm.cor)?_c('v-chip',{attrs:{"small":"","label":"","text-color":"white","color":_vm.cor}},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }